import { CubeMenu } from "../../../app/access-control/permissions";

export interface CubeApplication {
  name: string;
  permission: string;
  access: boolean;
  label: string;
}

export const generateApplications = (): CubeApplication[] => {
  return [
    {
      name: "Location",
      permission: CubeMenu.Company,
      access: false,
      label: "Location",
    },
    {
      name: "oldPatientsApp",
      permission: CubeMenu.OldPatient,
      access: false,
      label: "Old Patients",
    },
    {
      name: "Patient",
      permission: CubeMenu.Patient,
      access: false,
      label: "Patients",
    },
    {
      name: "LegacyBilling",
      permission: CubeMenu.LegacyBilling,
      access: true,
      label: "Legacy Billing",
    },
    {
      name: "HISHOPEICON",
      permission: CubeMenu.HIS,
      access: false,
      label: "HIS/HOPE",
    },
    {
      name: "Workforce",
      permission: CubeMenu.Workforce,
      access: false,
      label: "Workforce",
    },
    {
      name: "ResourceManagement",
      permission: CubeMenu.ResourceManagement,
      access: false,
      label: "Resource Management",
    },
    {
      name: "Facilities",
      permission: CubeMenu.Facilities,
      access: false,
      label: "Facilities",
    },
    {
      name: "Reports",
      access: false,
      permission: CubeMenu.Reports,
      label: "Reports",
    },
    {
      name: "Analytics",
      permission: CubeMenu.Analytics,
      access: false,
      label: "Analytics",
    },
    {
      name: "CommunityBereavement",
      permission: CubeMenu.CommunityBereavement,
      access: false,
      label: "Community Bereavement",
    },
    {
      name: "Billing",
      permission: CubeMenu.Billing,
      access: false,
      label: "Billing",
    },
    {
      name: "OrderManagement",
      permission: CubeMenu.OrderManagement,
      access: false,
      label: "Order Management",
    },
    {
      name: "EPrescribe",
      permission: CubeMenu.Eprescribe,
      access: false,
      label: "eRx",
    },
    {
      name: "LegacyApp",
      permission: CubeMenu.LegacyApp,
      access: false,
      label: "Legacy Applications",
    },
    {
      name: "ReferralAndIntake",
      permission: CubeMenu.ReferralAndIntake,
      access: false,
      label: "Referral Management",
    },
    {
      name: "ChartMeds",
      permission: CubeMenu.ChartMeds,
      access: false,
      label: "ChartMeds",
    },
    {
      name: "WestFax",
      permission: null,
      access: true,
      label: "Fax",
    },
    {
      name: "WorldViewFax",
      permission: null,
      access: true, // its true because this is managed by the toggle only and not permissions
      label: "WorldView",
    },
  ];
};



// WEBPACK FOOTER //
// ./src/navigation/components/navigation-header/cube-application.ts